import { createFileRoute } from "@tanstack/react-router";
import AdminTeammateLinkage from "@/pages/AdminTeammateLinkage";

export const Route = createFileRoute("/admin/teammate-linkage/")({
  component: AdminTeammateLinkage,
});
